import React from 'react';
import { IBubble } from '../../Interfaces/IBubbles';
import BackBtn from "../BackButton/BackButton";
import './BubbleDetail.css';

interface BubbleDetailProps {
  bubble?:  IBubble | null;
}

const BubbleDetail: React.FC<BubbleDetailProps> = ({ bubble }) =>{
  if (!bubble) return <p>Chargement...</p>;

  return (
    <div className='TitleContainer'>
      <BackBtn></BackBtn>
      <h1 className='OpenedBubbleTitle'>{bubble.Title}</h1>
      <p className='OpenedBubbleDesc'>{bubble.Description}</p>
    </div>
  );
};

export default BubbleDetail;